import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, withFirestore } from 'react-redux-firebase'
import { compose } from 'redux'

import { hasRole } from '../../helpers/auth'
import { deleteTournamentHelper } from '../../helpers/delete-tournament'
import { findInOrdered, fsCollections } from '../../helpers/firestore'
import { clearTournament, selectTournament } from '../../redux/modules/tournaments'

import { TenantId } from '../../schemas/Tenant'
import { Tournament } from '../../schemas/Tournament'

import TournamentMenu from './TournamentMenu'

type TournamentContainerProps = {
  admin: boolean
  children: any[]
  className?: string
  tournament: Tournament
  currentTournament: Tournament
  tenant: string
  removeTournament(id: string): void
  selectTournament(tenant: TenantId, tournament: Tournament): void
  clearTournament(): void
}

class TournamentContainer extends React.Component<TournamentContainerProps, any> {
  componentDidUpdate(prevProps, prevState, snapshot) {
    // need to pass `currentTournament` otherwise - call stack overflow
    if (prevProps.tournament.name && !this.props.currentTournament) {
      this.props.selectTournament(prevProps.tenant, prevProps.tournament)
    }
  }

  componentWillUnmount() {
    this.props.clearTournament()
  }

  render() {
    const {
      admin,
      children,
      className = 'ant-col-12 ant-col-offset-6',
      tournament,
      tenant,
      removeTournament,
    } = this.props

    return (
      <div className={`container ${className}`}>
        {tournament && tournament.id && (
          <TournamentMenu
            tenant={tenant}
            admin={admin}
            tourney={tournament}
            removeTournament={removeTournament}
          />
        )}
        {children}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { firestore, settings, firebase, tournaments } = state
  const { tournamentId } = ownProps

  const { tenant } = settings
  const tournament = findInOrdered(
    firestore.ordered[fsCollections.tournaments(tenant)],
    tournamentId,
  )

  return {
    admin: hasRole('admin', tenant, firebase.profile),
    tenant,
    tournament: {
      ...tournament,
      id: tournamentId, // needed by TournamentMenu
    },
    tournamentCategories:
      firestore.ordered[fsCollections.tournamentCategories(tenant, tournamentId)],
    tournamentPlayers: firestore.ordered[fsCollections.tournamentPlayers(tenant, tournamentId)],
    currentTournament: tournaments.currentTournament,
  }
}

export default compose<FIXME>(
  withFirestore,
  firestoreConnect<FIXME>(({ tenant, tournamentId }) => [
    { collection: fsCollections.tournaments(tenant), doc: tournamentId },
  ]),
  connect(mapStateToProps, { selectTournament, clearTournament }),
  deleteTournamentHelper,
)(TournamentContainer)



// WEBPACK FOOTER //
// ./src/components/tournament/TournamentContainer.tsx